import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';

@Injectable()
export class DocumentVerificationService {
  private apiGatewayUrl = environment.apiGatewayUrl;
  private checkExistsByDocumentUrl = `${this.apiGatewayUrl}onboarding-service/public/originations/check-exists/document/{docNumber}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public existsByDocTypeAndNumber(docType: number, docNumber: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<CustomResponseDto<boolean>>(
      `${this.checkExistsByDocumentUrl.replace('{docNumber}', docNumber)}?typeDocument=${docType}`,
      { headers: this.headers }
    );
  }
}
